import { Group, Skeleton, Stack, Text, Timeline } from '@mantine/core';
import type { ReactNode } from 'react';

type ActivityTimelineItem = {
  id: string | number;
  title: string;
  icon: ReactNode;
  description?: ReactNode;
};

type ActivityTimelineProps = {
  activities: ActivityTimelineItem[];
  loading?: boolean;
};

function ActivityTimeline({
  activities,
  loading = false,
}: ActivityTimelineProps) {
  if (loading && activities.length === 0) {
    return (
      <Stack gap="lg">
        <Group pl="lg">
          <Stack gap="lg" w="100%">
            {Array.from({ length: 5 }).map((_, index) => (
              <Group key={index} align="flex-start">
                <Skeleton width={32} height={32} circle />
                <Stack gap="xs" flex={1}>
                  <Skeleton height={14} width={160} radius="sm" />
                  <Skeleton height={12} width={220} radius="xs" />
                </Stack>
              </Group>
            ))}
          </Stack>
        </Group>
      </Stack>
    );
  }

  return (
    <Stack gap="lg">
      <Group pl="lg">
        <Timeline
          bulletSize={32}
          lineWidth={2}
          color="blue.1"
          active={activities.length}
        >
          {activities.map((item) => (
            <Timeline.Item
              key={item.id}
              bullet={item.icon}
              title={<Text size="xs">{item.title}</Text>}
            >
              {item.description &&
                (typeof item.description === 'string' ? (
                  <Text size="xs" c="dimmed" mt={4}>
                    {item.description}
                  </Text>
                ) : (
                  item.description
                ))}
            </Timeline.Item>
          ))}
        </Timeline>
      </Group>
    </Stack>
  );
}

export {
  ActivityTimeline,
  type ActivityTimelineItem,
  type ActivityTimelineProps,
};
